import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { Box, BoxProps } from '@rover/kibble/core';

export type Height = 'auto' | number | `${number}%`;

const AnimatedBox = styled(Box)`
  transition: height 0.2s ease-in-out;
`;

type AutoHeightProps = BoxProps & {
  children: React.ReactNode;
};

const AutoHeight = ({ children, ...props }: AutoHeightProps): JSX.Element => {
  const [height, setHeight] = useState<Height>('auto');
  const contentDiv = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // If the observer is undefined, exit early and don't init them
    if (typeof ResizeObserver === 'undefined') {
      return () => {};
    }

    const resizeObserver = new ResizeObserver(() => {
      if (contentDiv.current) {
        setHeight(contentDiv.current.clientHeight);
      }
    });

    if (process.env.JS_ENV_CLIENT && contentDiv.current) {
      resizeObserver.observe(contentDiv.current);
    }
    return () => {
      if (process.env.JS_ENV_CLIENT) {
        resizeObserver.disconnect();
      }
    };
  }, [contentDiv]);

  return (
    <AnimatedBox width="100%" height={height}>
      <Box ref={contentDiv} {...props}>
        {children}
      </Box>
    </AnimatedBox>
  );
};

export default AutoHeight;
